import React from 'react'
import { LogisticVendorOrShipToEnum } from '@ztechapps/common.contract'
import type { InlineInputProps } from '@ztechapps/webui.input'
import { buildEnumOptions, SelectInlineInput } from '@ztechapps/webui.input'

const logisticVendorOrShipToOptions = buildEnumOptions(LogisticVendorOrShipToEnum)

// Bakes the fixed option list into a plain `InlineInputProps` component, the same shape
// LogisticShipViaSelectInlineInput (../LogisticShipViaSelect/index.tsx) uses to carry its own
// select options through — LogisticInlineInput's `parentInputComponent` is typed as
// `FunctionComponent` on plain `InlineInputProps`, so `selectOptions` cannot be threaded through
// it directly; this wrapper absorbs that prop before `LogisticInlineInput` ever sees it.
export const LogisticVendorOrShipToSelectInlineInput = (props: InlineInputProps) => {
  return <SelectInlineInput selectOptions={logisticVendorOrShipToOptions} {...props} />
}
